import { render, staticRenderFns } from "./NewAlarmFeedback.vue?vue&type=template&id=70eb7073&"
import script from "./NewAlarmFeedback.vue?vue&type=script&lang=js&"
export * from "./NewAlarmFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports